import { render, staticRenderFns } from "./AppMessage.vue?vue&type=template&id=09f40416"
import script from "./AppMessage.vue?vue&type=script&lang=js"
export * from "./AppMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports